"use client";

import React from "react";
import { ArrowDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Hero() {
  return <section data-section-id="144413" id="dentures-overview" className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden light bg-background text-foreground">
      <style>
        {`
          @keyframes slowPan {
            0% { transform: scale(1) translate(0, 0); }
            50% { transform: scale(1.05) translate(-1%, -1%); }
            100% { transform: scale(1) translate(0, 0); }
          }
          .animate-slow-pan {
            animation: slowPan 40s ease-in-out infinite;
          }
          
          @keyframes pulseGlow {
            0% { box-shadow: 0 0 10px 0px color-mix(in srgb, var(--color-primary) 40%, transparent); }
            50% { box-shadow: 0 0 25px 5px color-mix(in srgb, var(--color-primary) 60%, transparent); }
            100% { box-shadow: 0 0 10px 0px color-mix(in srgb, var(--color-primary) 40%, transparent); }
          }
          .animate-pulse-glow {
            animation: pulseGlow 3s infinite;
          }
        `}
      </style>

      {}
      <div className="absolute inset-0 z-0 overflow-hidden">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617360/img/tampa_estate_sunset_hero.png" alt="Lush Tampa estate at sunset" className="w-full h-full object-cover animate-slow-pan" />
      </div>

      {}
      <div className="absolute inset-0 z-10 bg-white/40 backdrop-blur-[1px]"></div>

      {}
      <div className="relative z-20 flex flex-col items-center text-center px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto mt-16">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif font-bold text-foreground drop-shadow-sm tracking-tight mb-6 leading-tight">
          Comfort & Confidence with Custom-Fit Dentures
        </h1>
        
        <p className="text-lg md:text-xl font-sans font-medium text-foreground/80 max-w-2xl mb-10 drop-shadow-none">
          Experience clinical excellence and compassionate care in El Monte. Our advanced technology ensures affordable, high-quality dentures tailored to your unique smile.
        </p>
        
        <Link to="/ContactUsPage">
          <Button size="lg" className="rounded-full bg-primary text-primary-foreground hover:bg-primary/90 text-lg px-10 h-14 font-semibold transition-all duration-300 animate-pulse-glow border-none shadow-lg">
            Free Fitting Consultation
          </Button>
        </Link>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-2 text-foreground/70">
        <span className="text-sm font-sans font-semibold tracking-widest uppercase opacity-80">Explore Our Quality</span>
        <div className="animate-bounce mt-1">
          <ArrowDown className="w-5 h-5 opacity-80 text-primary" strokeWidth={2} />
        </div>
      </div>
    </section>;
}